"use strict";
/**
 * ! This component re-renders every second and always exist, do not put any requests or heavy calculations in this component
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useExpressOrders_1 = __importDefault(require("../../../Hooks/useExpressOrders"));
const svg_components_1 = require("../../../assets/svg-components");
const Typography_1 = require("../../UI/Typography");
const style = __importStar(require("./styled"));
const react_redux_1 = require("react-redux");
const ExpressBanner = ({ bannerText, expiredText, canSeeBanner }) => {
    const { remaining } = (0, useExpressOrders_1.default)();
    const { expressAvailable } = (0, react_redux_1.useSelector)((state) => state.siteSettings);
    return remaining && canSeeBanner ? (react_1.default.createElement(style.BannerContainer, null,
        react_1.default.createElement(svg_components_1.ShippingBoxIcon, null),
        react_1.default.createElement(style.BannerText, { type: Typography_1.Types.BODY_2 }, expressAvailable ? `${bannerText} ${remaining.time}` : expiredText))) : null;
};
exports.default = ExpressBanner;
